module.exports = __webpack_public_path__ + "static/media/mail.54c65a40.svg";